import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import { LOG_IN_TOKEN } from "../reducers/types";
import { authThunks } from "../actions-thunks/auth-thunks";
import { utilityFns } from "../ui/utilities/utility-functions";

import "../App.scss";

const ProtectedRoute = () => {
  const { authenticated } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const onboardingToken = searchParams.get(LOG_IN_TOKEN);

  useEffect(() => {
    if (onboardingToken) {
      const domain = utilityFns.getDomainFromHostname(window?.location.hostname);
      if (window.location.hostname === "localhost") {
        localStorage.setItem(LOG_IN_TOKEN, onboardingToken)
      } else {
        Cookies.set(LOG_IN_TOKEN, onboardingToken, {
          expires: 30,
          domain,
          sameSite: "None",
          secure: true,
        });
      }
      dispatch(authThunks.checkTokenTC(true));
    }
    
    if (!authenticated) {
      dispatch(authThunks.checkTokenTC());
    }
  }, [authenticated, dispatch, onboardingToken]);

  return authenticated && <Outlet />;
};

export default ProtectedRoute;
